import "chart.js/auto";
import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import moment from "moment";
import axios from "axios";
import { indianNumberFormat } from "../../../utils/handlers";

import { useSelector } from "react-redux";

const Depreciation = ({ vehicle }) => {
  const token = sessionStorage.getItem("token");
  const config = {
    headers: { Authorization: token },
  };

  const labels = [
    moment(vehicle?.registration_details?.date, "DD/MM/YYYY").format("ll"),
    3.3,
    "Today",
  ];

  const data = {
    labels: labels,
    datasets: [
      {
        label: "",
        data: [6, 2.67, 1.7],
        borderColor: "#00394D",
        pointBackgroundColor: function (context) {
          var index = context.dataIndex;
          return index === 0 ? "#0BA300" : "#D30D00";
        },
      },
    ],
  };

  const options = {
    lineTension: 0.4,
    bezierCurve: true,
    responsive: true,
    pointRadius: function (context) {
      let index = context.dataIndex;
      if (index === 1) {
        return 1;
      } else {
        return 3;
      }
    },
    layout: {
      padding: { left: 50, right: 50, top: 20, bottom: 20 },
      backgroundColor: "black",
    },
    plugins: {
      background: {
        color: "#E6EBED",
      },
      linePlugin: {
        color: "#000000",
      },
      legend: {
        position: "none",
      },
      tooltip: {
        position: "nearest",
        intersect: false,
        callbacks: {
          label: function (context) {
            var label;
            if (context.dataIndex === 0) {
              label = [
                `Purchased Value           ₹ ${indianNumberFormat(
                  vehicle?.purchase_price
                )}`,
                `Current Value                 ₹ ${indianNumberFormat(
                  vehicle?.current_price
                )}\n\n`,
                `Depreciation Value        ₹ ${indianNumberFormat(
                  vehicle?.purchase_price - vehicle?.current_price
                )}\n`,
              ];
            } else {
              label = [
                `Current Value                 ₹ ${indianNumberFormat(
                  vehicle?.current_price
                )}\n\n`,
                `Purchased Value           ₹ ${indianNumberFormat(
                  vehicle?.purchase_price
                )}`,

                `Depreciation Value        ₹ ${indianNumberFormat(
                  vehicle?.purchase_price - vehicle?.current_price
                )}\n`,
              ];
            }
            return label;
          },
        },
        filter: function (tooltipItem) {
          return tooltipItem.dataIndex !== 1;
        },
      },
    },
    scales: {
      y: {
        ticks: {
          display: false,
        },
        grid: {
          display: false,
        },
        offset: true,
        beginAtZero: true,
        suggestedMin: 1,
        suggestedMax: 10,
        border: {
          width: 2,
          color: "#C1C1C1",
        },
      },
      x: {
        grid: {
          display: false,
          color: "#E0E0E0",
          lineWidth: 1,
        },
        ticks: {
          autoSkip: true,
          maxTicksLimit: 2,
        },
        offset: true,
        border: {
          width: 2,
          color: "#C1C1C1",
        },
        height: "10px",
      },
    },
    maintainAspectRatio: true,
  };
  const plugin = {
    id: "background",
    beforeDraw: (chart, args, opts) => {
      if (!opts.color) {
        return;
      }
      const { ctx, chartArea } = chart;

      ctx.fillStyle = opts.color;
      ctx.fillRect(
        chartArea.left,
        chartArea.top,
        chartArea.width,
        chartArea.height
      );
    },
  };

  const linePlugin = {
    id: "linePlugin",
    afterRender: function (c, options) {
      let meta = c.getDatasetMeta(0),
        max;
      c.ctx.save();
      c.ctx.strokeStyle = c.config._config.options.scales.x.grid.color;
      c.ctx.lineWidth = c.config._config.options.scales.x.grid.lineWidth;
      c.ctx.beginPath();
      meta.data.forEach(function (e, index) {
        if (
          max == undefined ||
          c.config._config.data.datasets[0].data[index] > max
        ) {
          max = c.config._config.data.datasets[0].data[index];
        }
        if (index !== 1) {
          c.ctx.moveTo(e.x, 175);
          c.ctx.lineTo(e.x, e.y);
        }
      });
      c.ctx.textBaseline = "top";
      c.ctx.textAlign = "right";
      c.ctx.fillStyle = "black";
      c.ctx.stroke();
      c.ctx.restore();
    },
  };

  return (
    <>
      <p className="  font-bold text-[22px] text-[#262626]">
        Depreciation Value{" "}
      </p>
      <div className=" pr-4 pb-4 w-full  bg-white rounded-lg mt-3">
        <div
          style={{
            backgroundColor: "#E6EBED",
            borderRadius: "8px",
          }}
        >
          <Line options={options} data={data} plugins={[plugin, linePlugin]} />
        </div>
        <p className="bg-[#F7F5D0] py-[6px] px-3 border border-[#E2ECFF] text-[#262626] text-[10px] font-bold rounded-lg mt-6">
          <b>Note:</b> The value may fluctuate within a range of ±10%.
        </p>
        {/* {expand && (
        <div className="mt-4 h-[1px] w-full border border-solid border-[#e0e0e0]"></div>
      )} */}
        <div className="flex justify-between mt-5 items-center px-3">
          <div className="flex flex-row items-center gap-3">
            <div className="w-3 h-3 rounded-sm bg-[#0BA300] "></div>
            <p className="font-semibold text-sm text-[#333333]">
              Purchased Value
            </p>
          </div>
          <p className="font-bold text-xs text-[#333333]">
            &#8377;{indianNumberFormat(vehicle?.purchase_price)}
          </p>
        </div>
        <div className="flex items-center justify-between mt-5 px-3">
          <div className="flex flex-row items-center gap-3">
            <div className="w-3 h-3 rounded-sm bg-[#DBA12C] "></div>

            <p className="font-semibold text-sm text-[#333333] ">
              Current Value
            </p>
          </div>
          <p className="font-bold text-xs text-[#333333]">
            &#8377; {indianNumberFormat(vehicle?.current_price)}
          </p>
        </div>
        <div className="flex items-center justify-between mt-5 px-3">
          <div className="flex flex-row items-center gap-3">
            <div className="w-3 h-3 rounded-sm bg-[#D30d00] "></div>

            <p className="font-semibold text-sm text-[#333333] ">
              Depreciated Amount
            </p>
          </div>
          <p className="font-bold text-xs text-[#333333]">
            &#8377;{" "}
            {indianNumberFormat(
              vehicle?.purchase_price - vehicle?.current_price
            )}
          </p>
        </div>
      </div>
    </>
  );
};

export default Depreciation;
